// Shared choices for creating and editing jobs, so every job form offers the
// same options (Schedule Job dialog, job details on the Service Schedule).

export const JOB_TYPES = [
  { value: 'RESIDENTIAL', label: 'Residential' },
  { value: 'VACATION_RENTAL', label: 'Vacation Rental' },
  { value: 'COMMERCIAL', label: 'Commercial' },
];

export const SERVICE_TYPES = [
  { value: 'regular', label: 'Regular' },
  { value: 'deep_clean', label: 'Deep Clean' },
  { value: 'move_in', label: 'Move In' },
  { value: 'move_out', label: 'Move Out' },
  { value: 'one_time', label: 'One Time' },
  { value: 'post_construction', label: 'Post Construction' },
];

export const JOB_STATUSES = [
  { value: 'NOT_STARTED', label: 'Not Started' },
  { value: 'IN_PROGRESS', label: 'In Progress' },
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'CANCELLED', label: 'Cancelled' },
];

// Common visit lengths, in minutes
export const DURATION_OPTIONS = [60, 90, 120, 150, 180, 210, 240, 300, 360, 420, 480];

/** 90 → "1h30", 120 → "2h", 45 → "45 min" */
export const formatDuration = (minutes) => {
  const total = Number(minutes) || 0;
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (!h) return `${m} min`;
  return m ? `${h}h${String(m).padStart(2, '0')}` : `${h}h`;
};

/** Duration choices that always include the job's current value. */
export const durationChoices = (current) => {
  const value = Number(current);
  return !value || DURATION_OPTIONS.includes(value)
    ? DURATION_OPTIONS
    : [...DURATION_OPTIONS, value].sort((a, b) => a - b);
};

/**
 * Payouts on jobs scheduled before this date came from the old automatic rule
 * and are wrong (confirmed by the business, 2026-10-06): they aren't shown.
 * Keep in sync with PAYOUTS_SHOWN_FROM in primeshine-back/src/routes/jobRoutes.js.
 */
export const PAYOUTS_SHOWN_FROM = new Date('2026-10-06T00:00:00-04:00');
export const payoutShownFor = (scheduledDate) =>
  Boolean(scheduledDate && new Date(scheduledDate) >= PAYOUTS_SHOWN_FROM);
